import { DataElement, PaginationParams } from "./common";
import { UiUser } from "./ui-user.model";

export class AgentTask {
  taskId: number;
  taskUser: UiUser;
  clinic: DataElement;
  title: string;
  taskNotes: string;
  userNotes: string;
  crDate: Date;
  dueDate: Date;
  createdBy: DataElement;
  completeDate: Date;
  updUser: DataElement;
  updDate: Date;
  status: DataElement;
}

export class AgentTaskSearchParams extends PaginationParams {
  clinicId?: number;
  taskUserId?: number;

  constructor() {
    super();
  }
}

export class TaskStatusEnum {
  public static OPEN: string = "OPEN";
  public static CLOSED: string = "CLOSED";
  public static CANCELLED: string = "CANCELLED";
}
